<template>
  <div class="details-page">
    <site-header />
    <div class="content-wrapper">
      <!-- 左侧扫码分享 -->
      <aside class="share-panel">
        <div class="share-card">
          <div class="share-title">扫码分享</div>
          <div class="share-qr-wrap">
            <qrcode-vue v-if="shareUrl" :value="shareUrl" :size="110" level="M" class="share-qr" />
          </div>
          <p class="share-tip">微信扫一扫<br>打开本篇文章</p>
          <!-- <p class="share-url" :title="shareUrl">{{ shareUrlDisplay }}</p> -->
          <div class="share-actions">
            <button type="button" class="share-btn share-btn-wechat" @click="showWechatTip">
              <span class="share-icon share-icon-wechat">微</span>
              微信
            </button>
            <button type="button" class="share-btn" @click="copyShareLink">
              <span class="share-icon">链</span>
              复制链接
            </button>
          </div>
        </div>
      </aside>

      <div class="article-container">
        <h1 class="article-title">{{ articleData.title || articleData.name }}</h1>
        <div class="article-meta">
          <span class="date">发布时间：{{ formatDate(articleData.createTime) }}</span>

          <!-- <span class="category">分类：{{ articleData.categoryName }}</span> -->
          <span v-if="articleData.writer" class="writer">作者：{{ articleData.writer }}</span>
          <span v-if="articleData.modifyTime" class="modify-time">更新时间：{{ formatDate(articleData.modifyTime) }}</span>
          <span class="views">浏览量：{{ articleData.views || 0 }}</span>
        </div>
        <img v-if="articleData.cover" :src="articleData.cover" class="article-cover" alt="文章封面">

        <div class="article-content" v-html="articleData.contents || articleData.summary"></div>
      </div>
      <!-- Recommended Articles Sidebar -->
      <div class="recommended-articles">
        <h2 class="recommended-title">推荐文章</h2>
        <div class="article-list">
          <template v-if="listType === 'policy' && policyList.length">
            <div v-for="(item, index) in policyList" :key="item.id || index" class="article-item"
              @click="goToPolicyDetail(item)">
              <img v-if="item.messageImg" :src="item.messageImg" :alt="item.title" class="article-image">
              <div class="article-item-title">{{ item.title }}</div>
              <div class="article-item-date">{{ item.releaseTime }}</div>
            </div>
          </template>
          <template v-else-if="listType === 'news' && newsListFromHome.length">
            <div v-for="(item, index) in newsListFromHome" :key="item.id || index" class="article-item"
              @click="goToNewsDetail(item)">
              <img :src="item.messageImg" :alt="item.messageName" class="article-image">
              <div class="article-item-title">{{ item.messageName }}</div>
            </div>
          </template>
          <template v-else-if="listType === 'project' && projectList.length">
            <div v-for="(item, index) in projectList" :key="item.id || index" class="article-item"
              @click="goToProjectDetails(item)">
              <img :src="item.cover" :alt="item.title" class="article-image">
              <div class="article-item-title">{{ item.title }}</div>
              <div class="article-item-date" v-if="item.itemTime">{{ item.itemTime.split(' ')[0] }}</div>
            </div>
          </template>
          <p v-else class="recommended-empty">暂无推荐</p>
        </div>
      </div>
    </div>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import QrcodeVue from "qrcode.vue";
import {
  getNewsMessageById,
  getLtCodificationDa,
  getNewsMessage,
  getLtCodificationDalist,
  getProjectList,
  getLtItemDaInfo
} from "@/api/website";

export default {
  name: "ArticleDetails",
  components: {
    SiteHeader,
    SiteFooter,
    QrcodeVue,
  },
  data() {
    return {
      articleData: {
        title: '',
        categoryName: '',
        createTime: '',
        contents: '',
        cover: ''
      },
      newsListFromHome: [],
      projectList: [],
      policyList: [],
      listType: '', // news | policy | project
      policyType: '1'
    };
  },
  computed: {
    /** localhost 微信扫码必现「网络出错」；局域网 IP 同 WiFi 一般可打开 */
    isLocalShare() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname || '';
      return host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0';
    },
    /**
     * 生成可扫码打开「当前文章」的绝对链接。
     * 只带 id/type/from 等必要参数，避免过长导致二维码难识别。
     */
    shareUrl() {
      if (typeof window === 'undefined') return '';
      const query = this.$route.query || {};
      const shareQuery = {};
      if (query.id != null && query.id !== '') shareQuery.id = String(query.id);
      if (query.type != null && query.type !== '') shareQuery.type = String(query.type);
      if (query.from != null && query.from !== '') shareQuery.from = String(query.from);
      // 兰台研读等必须带 item 才能还原内容（控制长度）
      if (query.item && String(query.item).length < 600) {
        shareQuery.item = String(query.item);
      }

      const envOrigin = (process.env.VUE_APP_SHARE_ORIGIN || '').replace(/\/$/, '');
      let origin = window.location.origin;
      // 本地开发：若配置了正式站域名，二维码指向正式站对应文章页
      if (envOrigin && (origin.includes('localhost') || origin.includes('127.0.0.1'))) {
        origin = envOrigin;
      }

      try {
        const resolved = this.$router.resolve({
          path: '/details',
          query: shareQuery
        });
        let path = resolved.href || resolved.route.fullPath || '/details';
        // resolve 可能返回带域名的完整地址，统一成 path
        if (/^https?:\/\//i.test(path)) {
          return path;
        }
        if (!path.startsWith('/')) path = '/' + path;
        return origin + path;
      } catch (e) {
        return window.location.href.split('#')[0];
      }
    },
    shareUrlDisplay() {
      const url = this.shareUrl || '';
      if (url.length <= 36) return url;
      return url.slice(0, 18) + '...' + url.slice(-14);
    }
  },
  created() {
    this.initPage();
  },
  watch: {
    '$route'(to, from) {
      if (to.path !== '/details') return;
      const idChanged = to.query.id !== from.query.id;
      const typeChanged = to.query.type !== from.query.type;
      const fromChanged = to.query.from !== from.query.from;
      const itemChanged = to.query.item !== from.query.item;
      if (idChanged || typeChanged || fromChanged || itemChanged) {
        this.fetchArticleData();
      }
      if (typeChanged || fromChanged || !this.listType) {
        this.fetchRecommendedList();
      }
    }
  },
  methods: {
    initPage() {
      this.fetchArticleData();
      this.fetchRecommendedList();
    },
    showWechatTip() {
      const msg = this.isLocalShare
        ? '当前是本地地址，微信扫码会网络出错。请用电脑局域网IP打开本站后再扫，或部署到线上后扫码。'
        : '请使用微信扫描左侧二维码，即可打开本篇文章';
      if (this.$message) {
        this.$message({
          message: msg,
          type: this.isLocalShare ? 'warning' : 'success',
          duration: 4000
        });
      } else {
        alert(msg);
      }
    },
    async copyShareLink() {
      const url = this.shareUrl;
      if (!url) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const input = document.createElement('input');
          input.value = url;
          input.setAttribute('readonly', 'readonly');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        const tip = this.isLocalShare
          ? '链接已复制（本地地址，微信内可能打不开）'
          : '链接已复制，可粘贴到微信分享，打开即为本篇文章';
        if (this.$message) {
          this.$message.success(tip);
        } else {
          alert(tip);
        }
      } catch (e) {
        if (this.$message) {
          this.$message.error('复制失败，请手动复制地址栏链接');
        } else {
          alert('复制失败，请手动复制地址栏链接');
        }
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
        date.getDate()
      ).padStart(2, "0")}`;
    },
    /** 解析路由 query 中的对象（支持 JSON 字符串） */
    parseQueryObject(value) {
      if (!value) return null;
      if (typeof value === 'object') return value;
      if (typeof value !== 'string') return null;
      if (value === '[object Object]') return null;
      try {
        const decoded = decodeURIComponent(value);
        return JSON.parse(decoded);
      } catch (e) {
        try {
          return JSON.parse(value);
        } catch (e2) {
          return null;
        }
      }
    },
    /** 解析路由 query 中的列表（对象数组经 URL 会变成 [object Object]，需自行拉取） */
    parseQueryList(value) {
      if (!value) return [];
      if (Array.isArray(value)) {
        const valid = value.filter(item => item && typeof item === 'object' && item !== null && !Array.isArray(item) && Object.keys(item).length);
        if (valid.length) return valid;
        // 形如 ["[object Object]", ...] 则视为无效
        return [];
      }
      if (typeof value === 'string') {
        if (value === '[object Object]') return [];
        try {
          const parsed = JSON.parse(decodeURIComponent(value));
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [];
          } catch (e2) {
            return [];
          }
        }
      }
      return [];
    },
    resolveListType() {
      const query = this.$route.query;
      const from = query.from;
      if (from === 'policy' || (query.type && ['1', '2', '3'].includes(String(query.type)))) {
        this.policyType = String(query.type || '1');
        return 'policy';
      }
      if (from === 'project' || from === 'volume' || query.item) {
        return 'project';
      }
      if (from === 'news' || query.id || query.news) {
        return 'news';
      }
      return 'news';
    },
    async fetchRecommendedList() {
      const query = this.$route.query;
      const prevListType = this.listType;
      const prevPolicyType = this.policyType;
      this.listType = this.resolveListType();

      const passedNews = this.parseQueryList(query.newsList);
      const passedPolicy = this.parseQueryList(query.policyList);
      const passedProject = this.parseQueryList(query.projectList);

      if (passedNews.length) this.newsListFromHome = passedNews.slice(0, 6);
      if (passedPolicy.length) this.policyList = passedPolicy.slice(0, 6);
      if (passedProject.length) this.projectList = passedProject.slice(0, 6);

      const listTypeChanged = prevListType && prevListType !== this.listType;
      const policyTypeChanged =
        this.listType === 'policy' && prevPolicyType && prevPolicyType !== this.policyType;

      // 类型切换时清空旧列表，避免展示错误分类
      if (listTypeChanged || policyTypeChanged) {
        if (this.listType !== 'news') this.newsListFromHome = passedNews.length ? passedNews : [];
        if (this.listType !== 'policy' || policyTypeChanged) {
          this.policyList = passedPolicy.length && !policyTypeChanged ? passedPolicy : [];
        }
        if (this.listType !== 'project') this.projectList = passedProject.length ? passedProject : [];
      }

      try {
        if (this.listType === 'policy' && !this.policyList.length) {
          const res = await getLtCodificationDalist({
            type: this.policyType,
            pageNum: 1,
            pageSize: 6
          });
          if (res && (res.code === 200 || res.rows)) {
            this.policyList = (res.rows || []).slice(0, 6);
          }
        } else if (this.listType === 'news' && !this.newsListFromHome.length) {
          const res = await getNewsMessage({ pageNum: 1, pageSize: 6 });
          if (res && res.rows) {
            this.newsListFromHome = res.rows.slice(0, 6);
          }
        } else if (this.listType === 'project' && !this.projectList.length) {
          const res = await getProjectList({ type: 1, pageNum: 1, pageSize: 6 });
          if (res && (res.code === 200 || res.rows)) {
            this.projectList = (res.rows || []).slice(0, 6);
          }
        }
      } catch (error) {
        console.error('获取推荐文章失败:', error);
      }
    },
    goToProjectDetails(item) {
      if (!item || !item.id) return;
      // 兰台研读仍留在本页；其余项目研究走专用详情页
      if (this.$route.query.from === 'volume') {
        this.$router.push({
          path: '/details',
          query: {
            id: item.id,
            from: 'volume',
            item: encodeURIComponent(JSON.stringify(item))
          }
        });
        return;
      }
      this.$router.push({
        path: '/ProjectDetails',
        query: {
          id: item.id,
          type: 'project'
        }
      });
    },
    goToPolicyDetail(item) {
      if (!item || !item.id) return;
      this.$router.push({
        name: 'details',
        query: {
          id: item.id,
          type: this.policyType || this.$route.query.type || '1',
          title: item.title,
          releaseTime: item.releaseTime,
          from: 'policy'
        }
      });
    },
    goToNewsDetail(item) {
      if (!item || !item.id) {
        console.error('文章ID不存在');
        return;
      }
      this.$router.push({
        path: '/details',
        query: {
          id: item.id,
          from: 'news'
        }
      });
    },
    async fetchArticleData() {
      const query = this.$route.query;
      let articleData = null;

      if (query.id && query.type && ['1', '2', '3'].includes(String(query.type))) {
        try {
          const res = await getLtCodificationDa(query.id);
          if (res && res.code === 200 && res.data) {
            articleData = res.data;
          }
        } catch (error) {
          console.error("获取政策详情失败:", error);
        }
      } else if (query.id && (query.from === 'project' || query.from === 'volume')) {
        // 优先用路由里的完整 item；否则用项目详情接口 / 推荐列表兜底
        articleData = this.parseQueryObject(query.item);
        if (!articleData) {
          try {
            const res = await getLtItemDaInfo(query.id);
            if (res && res.code === 200 && res.data) {
              articleData = res.data;
            }
          } catch (error) {
            console.error("获取项目详情失败:", error);
          }
        }
        if (!articleData) {
          articleData = this.projectList.find(p => String(p.id) === String(query.id)) || null;
        }
      } else if (query.id) {
        try {
          const res = await getNewsMessageById({ id: query.id });
          if (res && res.code === 200 && res.data) {
            articleData = res.data;
          }
        } catch (error) {
          console.error("获取文章详情失败:", error);
        }
      } else if (query.notice) {
        articleData = this.parseQueryObject(query.notice) || query.notice;
      } else if (query.news) {
        articleData = this.parseQueryObject(query.news) || query.news;
      } else if (query.item) {
        articleData = this.parseQueryObject(query.item) || (typeof query.item === 'object' ? query.item : null);
      } else if (query.teacher) {
        articleData = this.parseQueryObject(query.teacher) || query.teacher;
      } else if (query.event) {
        articleData = this.parseQueryObject(query.event) || query.event;
      }

      if (articleData && typeof articleData === 'object') {
        this.articleData = {
          title: articleData.messageName || articleData.title || '',
          categoryName: articleData.source || articleData.categoryName || '未分类',
          createTime: articleData.createTime || articleData.releaseTime || articleData.itemTime || '',
          contents: articleData.messageContent || articleData.contents || articleData.content || '',
          cover: articleData.messageImg || articleData.cover || '',
          name: articleData.messageName || articleData.name || '',
          summary: articleData.messageDigest || articleData.summary || '',
          writer: articleData.createUserName || articleData.writer || '',
          modifyTime: articleData.modifyTime || '',
          views: articleData.seq || 0
        };
      }
    }
  }
};
</script>

<style scoped>
.details-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 100%;
}

.content-wrapper {
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  gap: 24px;
  align-items: flex-start;
  box-sizing: border-box;
}

.share-panel {
  width: 140px;
  flex-shrink: 0;
  position: sticky;
  top: 100px;
}

.share-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 16px 12px;
  text-align: center;
}

.share-title {
  font-size: 15px;
  font-weight: 600;
  color: #2d437c;
  margin-bottom: 12px;
}

.share-qr-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #eee;
}

.share-qr {
  display: block;
}

.share-tip {
  margin: 10px 0 6px;
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}

.share-url {
  margin: 0 0 12px;
  font-size: 10px;
  color: #999;
  word-break: break-all;
  line-height: 1.4;
  max-height: 2.8em;
  overflow: hidden;
}

.share-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.share-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #333;
  font-size: 12px;
  padding: 7px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.share-btn:hover {
  background: #f7f8fa;
  border-color: #d0d5dd;
}

.share-btn-wechat:hover {
  background: #f0faf4;
  border-color: #07c160;
  color: #07c160;
}

.share-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #eee;
  font-size: 11px;
  line-height: 1;
  flex-shrink: 0;
}

.share-icon-wechat {
  background: #07c160;
  color: #fff;
}

.article-container {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  flex: 1;
  min-width: 0;
  max-width: 680px;
  overflow-x: hidden;
  box-sizing: border-box;
}

.article-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 25px;
  text-align: center;
}

.article-meta {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.article-meta>span {
  margin: 0 10px;
}

.article-content {
  line-height: 1.8;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.article-content :deep(img) {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  display: block;
  margin: 10px auto;
}

.article-content :deep(p) {
  margin-bottom: 1em;
  max-width: 100%;
}

.article-content :deep(table) {
  max-width: 100%;
  overflow-x: auto;
  display: block;
}

.article-content :deep(pre) {
  max-width: 100%;
  overflow-x: auto;
}

.article-content :deep(video) {
  max-width: 100% !important;
  height: auto !important;
}

.article-cover {
  max-width: 100%;
  height: auto;
  margin: 20px auto;
  display: block;
  border-radius: 4px;
}

.recommended-articles {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 280px;
  flex-shrink: 0;
  margin-top: 0;
}

.recommended-title {
  font-size: 22px;
  color: #2d437c;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: left;
  border-bottom: 2px solid #eee;
  padding-bottom: 15px;
}

.recommended-empty {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.article-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.article-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.article-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.article-item:hover {
  background-color: #fafafa;
}

.article-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 10px;
}

.article-item-title {
  font-size: 14px;
  color: #333;
  text-align: left;
  flex-grow: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.article-item-date {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .details-page {
    width: 100vw;
    overflow-x: hidden;
  }

  .content-wrapper {
    flex-direction: column;
    padding: 10px;
    gap: 20px;
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;
  }

  .share-panel {
    display: none;
  }

  .article-container {
    max-width: 100%;
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .article-title {
    font-size: 20px;
    margin-bottom: 20px;
    text-align: left;
    word-wrap: break-word;
  }

  .article-meta {
    font-size: 12px;
    margin-bottom: 20px;
    padding-bottom: 15px;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .article-meta > span {
    margin: 0;
  }

  .article-content {
    font-size: 15px;
    line-height: 1.7;
    width: 100%;
    overflow-x: hidden;
  }

  .article-content :deep(img) {
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
    object-fit: contain;
  }

  .article-content :deep(p) {
    word-break: break-word;
  }

  .article-cover {
    margin: 15px 0;
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
  }

  .recommended-articles {
    width: 100%;
    padding: 20px;
    margin-top: 0;
    box-sizing: border-box;
  }

  .recommended-title {
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 12px;
  }

  .article-list {
    gap: 12px;
  }

  .article-item {
    padding-bottom: 12px;
  }

  .article-image {
    height: 120px;
    width: 100%;
    object-fit: cover;
  }

  .article-item-title {
    font-size: 13px;
    word-break: break-word;
  }

  .article-item-date {
    font-size: 11px;
  }
}

@media screen and (max-width: 480px) {
  .content-wrapper {
    padding: 8px;
    max-width: 100vw;
  }

  .article-container {
    padding: 12px;
    width: 100%;
  }

  .article-title {
    font-size: 18px;
  }

  .article-meta {
    font-size: 11px;
  }

  .article-content {
    font-size: 14px;
  }

  .article-content :deep(img) {
    max-width: 100% !important;
    width: 100% !important;
  }

  .recommended-articles {
    padding: 15px;
  }

  .recommended-title {
    font-size: 16px;
  }

  .article-image {
    height: 100px;
    width: 100%;
  }
}
</style>
